import { render } from "./FeaturesSectionComponent.vue?vue&type=template&id=353b27e5&scoped=true"
import script from "./FeaturesSectionComponent.vue?vue&type=script&lang=js"
export * from "./FeaturesSectionComponent.vue?vue&type=script&lang=js"

import "./FeaturesSectionComponent.vue?vue&type=style&index=0&id=353b27e5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-353b27e5"]])

export default __exports__